"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _yetAnotherReactLightbox = require("yet-another-react-lightbox");
var _inline = _interopRequireDefault(require("yet-another-react-lightbox/plugins/inline"));
var _thumbnails = _interopRequireDefault(require("yet-another-react-lightbox/plugins/thumbnails"));
var _download = _interopRequireDefault(require("yet-another-react-lightbox/plugins/download"));
var _zoom = _interopRequireDefault(require("yet-another-react-lightbox/plugins/zoom"));
require("yet-another-react-lightbox/styles.css");
require("yet-another-react-lightbox/plugins/thumbnails.css");
require("yet-another-react-lightbox/plugins/captions.css");
require("./thumbnails.css");
var _core = require("@stt-componentes/core");
var _core2 = require("@material-ui/core");
var _styles2 = require("@material-ui/core/styles");
var _axios = _interopRequireDefault(require("axios"));
var _plugin = _interopRequireDefault(require("./janelaDestacada/plugin"));
var _plugin2 = _interopRequireDefault(require("./rotacao/plugin"));
var _window = _interopRequireDefault(require("./window"));
var _reactResponsive = require("react-responsive");
var _captions2 = _interopRequireDefault(require("yet-another-react-lightbox/plugins/captions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles2.makeStyles)(function (theme) {
  return {
    selectSeries: {
      alignSelf: 'flex-end',
      marginBottom: theme.spacing(2)
    },
    notification: {
      display: 'flex',
      flexDirection: 'column'
    },
    divNotification: {
      margin: theme.spacing(2)
    },
    textoAjudaDestaque: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      color: 'white'
    },
    botaoFecharDestaque: {
      marginTop: theme.spacing(2)
    },
    container: {
      marginBottom: theme.spacing(2)
    },
    divNotificacaoDestacado: {
      width: 'auto',
      maxWidth: '100%',
      height: theme.spacing(50),
      backgroundColor: 'black',
      marginBottom: theme.spacing(2)
    },
    divCarregando: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(2),
      margin: theme.spacing(2)
    }
  };
});
var CONSTANTES_PLUGINS = {
  ROTACAO: _plugin2["default"],
  FULLSCREEN: _plugin["default"],
  THUMBNAILS: _thumbnails["default"],
  ZOOM: _zoom["default"],
  DOWNLOAD: _download["default"],
  CAPTIONS: _captions2["default"]
};
var GaleriaImagensTelediagnostico = function GaleriaImagensTelediagnostico(props) {
  var classes = useStyles({
    rotacao: 90
  });
  var idExame = props.idExame,
    config = props.config,
    tokenTelessaude = props.tokenTelessaude,
    strings = props.strings,
    _props$usePlugins = props.usePlugins,
    usePlugins = _props$usePlugins === void 0 ? ['ZOOM', 'FULLSCREEN', 'THUMBNAILS', 'ROTACAO', 'CAPTIONS'] : _props$usePlugins,
    _props$preload = props.preload,
    preload = _props$preload === void 0 ? 2 : _props$preload,
    _props$legendas = props.legendas,
    legendas = _props$legendas === void 0 ? null : _props$legendas;
  var EXAMES_API_BASE_URL = config.url_base_exames;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    series = _useState2[0],
    setSeries = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    serie = _useState4[0],
    setSerie = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    index = _useState6[0],
    setIndex = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    plugins = _useState8[0],
    setPlugins = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    slides = _useState0[0],
    setSlides = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    janelaDestacada = _useState10[0],
    setJanelaDestacada = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    galeriaCarregada = _useState12[0],
    setGaleriaCarregada = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    tokenImagem = _useState14[0],
    setTokenImagem = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    erroCarregamentoGaleria = _useState16[0],
    setErroCarregamentoGaleria = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    ordemBotoes = _useState18[0],
    setOrdemBotoes = _useState18[1];
  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1224px)'
  });
  var imagensController = (0, _react.useRef)();
  var _useState19 = (0, _react.useState)(null),
    _useState20 = _slicedToArray(_useState19, 2),
    windowPopuup = _useState20[0],
    setWindowPopup = _useState20[1];
  (0, _react.useEffect)(function () {
    window.addEventListener('error', function (e) {
      if (e.message === 'ResizeObserver loop limit exceeded') {
        var resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        var resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
      if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        var _resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        var _resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (_resizeObserverErr) {
          _resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (_resizeObserverErrDiv) {
          _resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
      }
    });
    pesquisarImagensExame();
    return function () {
      if (imagensController.current) {
        imagensController.current.abort();
      }
    };
  }, []);
  var rotacionar = function rotacionar(angulo) {
    var imgs = windowPopuup ? windowPopuup.document.getElementsByClassName('yarl__slide_image') : document.getElementsByClassName('yarl__slide_image');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img) {
        img.style.transform = "rotate(".concat(angulo, "deg)");
      }
    }
  };
  (0, _react.useEffect)(function () {
    var plugins = [_inline["default"]];
    var botoes = ['zoom', 'botoesRotacaoGaleria', 'botaoJanelaDestacada'];
    var _iterator = _createForOfIteratorHelper(usePlugins),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        switch (p) {
          case 'THUMBNAILS':
            if (isDesktop && slides && slides.length > 1) {
              plugins.push(CONSTANTES_PLUGINS[p]);
              botoes.push('thumbnails');
            }
            break;
          default:
            plugins.push(CONSTANTES_PLUGINS[p]);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setOrdemBotoes(botoes);
    setPlugins(plugins);
  }, [slides]);
  var pesquisarImagensExame = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (imagensController.current) {
              imagensController.current.abort();
            }
            imagensController.current = new AbortController();
            _axios["default"].get("".concat(EXAMES_API_BASE_URL, "/exame/").concat(idExame, "/imagem"), {
              headers: {
                Authorization: tokenTelessaude,
                'Content-Type': 'application/json'
              },
              signal: imagensController.current.signal
            }).then(function (response) {
              var data = response.data;
              var series = null;
              if (Array.isArray(data)) {
                series = data;
              } else {
                series = data.series;
                setTokenImagem(data.token);
              }
              var todasSeries = {
                seriesdescription: strings.todasImagens,
                seriesnumber: 0,
                instances: []
              };
              series.map(function (serie) {
                if (serie.instances) {
                  serie.instances.map(function (instance) {
                    todasSeries.instances.push(instance);
                  });
                }
              });
              series.unshift(todasSeries);
              setSeries(series);
              if (series.length) {
                setSlides(series[0].instances.map(function () {
                  return {
                    src: ''
                  };
                }));
              }
              setGaleriaCarregada(true);
            })["catch"](function (err) {
              console.log('Ocorreu um erro ao carregar as imagens do exame na galeria: ', err);
              setErroCarregamentoGaleria(true);
              setGaleriaCarregada(true);
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function pesquisarImagensExame() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (series.length > 0) {
      configurarArrayImagens(0);
    }
  }, [series]);
  var configurarArrayImagens = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(indiceSeries) {
      var imagens, values, i, imgData, srcArr, id, imgName;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            imagens = series[indiceSeries].instances;
            values = [];
            i = 0;
          case 1:
            if (!(i < imagens.length)) {
              _context2.n = 4;
              break;
            }
            imgData = {};
            if (legendas) {
              try {
                srcArr = imagens[i].split('/');
                id = srcArr[srcArr.length - 1];
                if (id.includes('Amz')) {
                  imgName = id.split('?')[0];
                  id = imgName.slice(0, imgName.lastIndexOf('.'));
                }
                imgData.description = legendas[id];
              } catch (error) {
                console.log(error);
              }
            }
            _context2.n = 2;
            return recuperarImagem(imagens[i]);
          case 2:
            imgData.src = _context2.v;
            values.push(imgData);
          case 3:
            i++;
            _context2.n = 1;
            break;
          case 4:
            setSlides(values);
          case 5:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function configurarArrayImagens(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var recuperarImagem = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(imagem) {
      var headers, response, blob, fileURL, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            headers = {};
            if (tokenImagem) {
              headers = {
                Authorization: "Bearer ".concat(tokenImagem)
              };
            } else {
              if (!imagem.includes('minio') && !imagem.includes('wado') && !imagem.includes('X-Amz-')) {
                headers = {
                  Authorization: tokenTelessaude
                };
              }
            }
            _context3.p = 1;
            _context3.n = 2;
            return _axios["default"].get(imagem, {
              headers: headers,
              responseType: 'blob'
            });
          case 2:
            response = _context3.v;
            blob = response.data;
            fileURL = URL.createObjectURL(blob);
            return _context3.a(2, fileURL);
          case 3:
            _context3.p = 3;
            _t = _context3.v;
            console.log('Erro ao recuperar imagem: ', imagem);
            console.log('Descrição do erro: ', _t);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function recuperarImagem(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var hangleChangeSerie = function hangleChangeSerie(event) {
    var serieValue = event.target.value;
    setSerie(serieValue);
    setIndex(0);
    configurarArrayImagens(serieValue);
  };
  var ComponenteGaleria = function ComponenteGaleria() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, series.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttNotification, {
      severity: "info",
      className: classes.divNotification
    }, /*#__PURE__*/_react["default"].createElement(_core.SttAlertTitle, null, strings.semImagens), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.notification
    }, /*#__PURE__*/_react["default"].createElement("span", null, strings.semImagensExibicao))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, erroCarregamentoGaleria && /*#__PURE__*/_react["default"].createElement(_core.SttNotification, {
      severity: "error",
      className: classes.divNotification
    }, /*#__PURE__*/_react["default"].createElement(_core.SttAlertTitle, null, strings.erro), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.notification
    }, /*#__PURE__*/_react["default"].createElement("span", null, strings.erroCarregamentoGaleria))), galeriaCarregada && !erroCarregamentoGaleria && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.container
    }, /*#__PURE__*/_react["default"].createElement(_yetAnotherReactLightbox.Lightbox, {
      index: index,
      toolbar: {
        buttons: [/*#__PURE__*/_react["default"].createElement(_core.SttSelect, {
          key: 'select-series',
          label: strings.series,
          value: serie,
          className: classes.selectSeries,
          onChange: hangleChangeSerie
        }, series.map(function (option, index) {
          return /*#__PURE__*/_react["default"].createElement(_core.SttMenuItem, {
            key: index,
            value: index
          }, option.seriesdescription);
        }))].concat(_toConsumableArray(ordemBotoes))
      },
      customLightboxProp: {
        setJanelaDestacada: setJanelaDestacada,
        janelaDestacada: janelaDestacada,
        rotacionar: rotacionar
      },
      slides: slides.map(function (slide, index) {
        return _objectSpread(_objectSpread({}, slide), {}, {
          title: "".concat(index + 1, "/").concat(slides.length)
        });
      }),
      plugins: plugins,
      carousel: {
        padding: 0,
        spacing: 0,
        imageFit: 'contain',
        preload: preload,
        infinite: true
      },
      inline: {
        style: {
          width: '100%',
          aspectRatio: '3 / 2',
          margin: '0 auto'
        }
      },
      zoom: {
        wheelZoomDistanceFactor: 500,
        scrollToZoom: true,
        maxZoomPixelRatio: 100
      },
      thumbnails: {
        padding: 0,
        gap: 10,
        imageFit: 'contain',
        showToggle: true
      },
      render: {
        slide: function slide(_ref4) {
          var _slide = _ref4.slide;
          if (_slide.src === '') {
            return /*#__PURE__*/_react["default"].createElement(_yetAnotherReactLightbox.LoadingIcon, {
              className: "yarl__icon yarl__slide_loading"
            });
          }
          if (!_slide.src) {
            return /*#__PURE__*/_react["default"].createElement("span", null, "Ocorreu um erro ao carregar esta imagem.");
          }
          return undefined;
        }
      },
      on: {
        view: function view(_ref5) {
          var currentIndex = _ref5.index;
          setIndex(currentIndex);
        }
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      smDown: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_core.SttNotification, {
      severity: "info",
      className: classes.divNotification
    }, /*#__PURE__*/_react["default"].createElement(_core.SttAlertTitle, null, "Dica"), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.notification
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Use as setas laterais ou a a\xE7\xE3o de arrastar para navegar entre as imagens."), /*#__PURE__*/_react["default"].createElement("span", null, "Use o scroll do mouse para aplicar zoom."), /*#__PURE__*/_react["default"].createElement("span", null, "Com zoom aplicado, voc\xEA pode usar o bot\xE3o esquerdo do mouse para movimentar a imagem para uma regi\xE3o de interesse.")))))))));
  };
  return galeriaCarregada ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, janelaDestacada ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divNotificacaoDestacado
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.textoAjudaDestaque
  }, /*#__PURE__*/_react["default"].createElement("span", null, "A galeria de imagens se encontra no modo destacado, em outra janela do seu navegador."), /*#__PURE__*/_react["default"].createElement("span", null, "Clique no bot\xE3o abaixo para retornar ao modo original."), /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
    variant: "contained",
    color: "primary",
    nomarginleft: "true",
    className: classes.botaoFecharDestaque,
    onClick: function onClick() {
      return setJanelaDestacada(false);
    }
  }, strings.fecharJanelaDestaque))), /*#__PURE__*/_react["default"].createElement(_window["default"], {
    title: "Visualiza\xE7\xE3o de imagens",
    name: "Visualiza\xE7\xE3o de imagens",
    onUnload: function onUnload() {
      setJanelaDestacada(false);
      setWindowPopup(null);
    },
    features: {
      width: '1200px',
      height: '800px'
    },
    copyStyles: true,
    setWindowPopup: setWindowPopup
  }, /*#__PURE__*/_react["default"].createElement(ComponenteGaleria, null))) : /*#__PURE__*/_react["default"].createElement(ComponenteGaleria, null)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divCarregando
  }, /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, {
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement(_core2.Typography, {
    variant: "h3",
    color: "primary"
  }, strings.carregandoGaleria));
};
GaleriaImagensTelediagnostico.propTypes = {
  strings: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(GaleriaImagensTelediagnostico);